import 'react-app-polyfill/ie11'; // must come first in project
import 'react-app-polyfill/stable';

import 'console-polyfill'; // Enables `console` in old IE
import 'core-js/es6/array';
import 'core-js/es6/string';

// polyfills required for the viewer to work with PhantomJS screenshot service
// (Note: it's dangerous to remove polyfills because *maybe* actually another system
// was depending on it unbeknownst to me or you)
import 'es6-weak-map/implement'; 
import 'core-js/es6/map';
import 'core-js/es6/set';
// End screenshotter polyfills

import 'promise-polyfill/src/polyfill'; // Enables `Promise` in IE

import 'raf/polyfill'; // Enables `requestAnimationFrame`
import 'classlist-polyfill'; // Need classList for react-onclickoutside

// polyfill object-fit and object-position for IE and edge for video bg sections
import 'objectFitPolyfill/dist/objectFitPolyfill.min.js';
// For url_utils and more
import 'url-polyfill';

// Polyfill the browser fetch API
import 'whatwg-fetch';
